/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type LoginQueryVariables = {};
export type LoginQueryResponse = {
    readonly configuration: {
        readonly passwordValidationMessage: string | null;
        readonly " $fragmentRefs": FragmentRefs<"NewPasswordRequiredChallengeFields_configuration">;
    } | null;
};
export type LoginQuery = {
    readonly response: LoginQueryResponse;
    readonly variables: LoginQueryVariables;
};



/*
query LoginQuery {
  configuration {
    passwordValidationMessage
    ...NewPasswordRequiredChallengeFields_configuration
  }
}

fragment NewPasswordRequiredChallengeFields_configuration on Configuration {
  passwordValidationRegex
  collectNameOnSignUp
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "passwordValidationMessage",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "LoginQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "NewPasswordRequiredChallengeFields_configuration"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoginQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "passwordValidationRegex",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "collectNameOnSignUp",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "b4f392925c95460826bd5f6033c73653",
            "id": null,
            "metadata": {},
            "name": "LoginQuery",
            "operationKind": "query",
            "text": "query LoginQuery {\n  configuration {\n    passwordValidationMessage\n    ...NewPasswordRequiredChallengeFields_configuration\n  }\n}\n\nfragment NewPasswordRequiredChallengeFields_configuration on Configuration {\n  passwordValidationRegex\n  collectNameOnSignUp\n}\n"
        }
    } as any;
})();
(node as any).hash = 'fd24261f9aff5eab16c000356dab5ecb';
export default node;
